/**
 * @desc 获取门店虚拟号
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** store_id */
  store_id: number;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse>(
    `/storeapi/api/v3/store/virtual-phone`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse;
export default req;
